export default __webpack_public_path__ + "./images/no.8a9d60d7.png";